module.exports = __webpack_public_path__ + "static/media/event12.0949247a.jpg";